// extracted by mini-css-extract-plugin
export var root = "K_wx";
export var wrapper = "K_ry";
export var image = "K_wy d_w d_y d_W";
export var imageWithHeight = "K_wz";
export var crop = "K_wB";
export var round = "K_wC";
export var fixedHeight = "K_wD";